export default __webpack_public_path__ + "award_gold.c8371de4.png";